import { render, staticRenderFns } from "./TextDownload.vue?vue&type=template&id=585f7ce9&scoped=true"
import script from "./TextDownload.vue?vue&type=script&lang=js"
export * from "./TextDownload.vue?vue&type=script&lang=js"
import style0 from "./TextDownload.vue?vue&type=style&index=0&id=585f7ce9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f7ce9",
  null
  
)

export default component.exports